import { FormFieldType } from "../../formField/FormFieldTypes";
import { INIT_TEXT_FIELD } from "../textField/TextField_init";
import { IGoogleFieldModel } from "./IGoogleInputFieldModel";

export const INIT_GOOGLE_TEXT_FIELD: Partial<IGoogleFieldModel> = {
  ...INIT_TEXT_FIELD,
  placeholder: "Search google place",
  value: "",
  type: FormFieldType.GoogleInput,
  borderStyle: "underline",
  validate: () => {
    return true;
  },
  inputType: "text",
  autoFocus: false,
  onBlur: () => { }
};
